import NetworkingOperations from "../index";

const PaymentDataTourist = (data) => {
	const url = process.env.REACT_APP_PAYMENT_GET_PAYMENT_DATA_TOURIST;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PaymentDataTourist;
